import { render, staticRenderFns } from "./Articlelist.vue?vue&type=template&id=f21bf472&scoped=true&"
import script from "./Articlelist.vue?vue&type=script&lang=js&"
export * from "./Articlelist.vue?vue&type=script&lang=js&"
import style0 from "./Articlelist.vue?vue&type=style&index=0&id=f21bf472&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21bf472",
  null
  
)

export default component.exports